import MainPage from './main-page.connect'

export default MainPage



// WEBPACK FOOTER //
// ./src/components/views/main-page/index.js